import './Input.css';

import React, { ReactNode } from 'react';

type Props = Readonly<{
  'data-test-id'?: string;
  accept?: string;
  label: string;
  onChange: (files: FileList | null) => void;
  children: ReactNode
}>;

export default function FileInput({
  accept,
  label,
  children,
  onChange,
  'data-test-id': dataTestId,
}: Props): JSX.Element {
  return (
    <div className="Input__wrapper">
      {label && <label className="Input__label">{label}</label>}
      <input
        type="file"
        accept={accept}
        className="Input__input"
        onChange={(e) => onChange(e.target.files)}
        data-test-id={dataTestId}
      />
      {children}
    </div>
  );
}
